import Vue from 'vue';
// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';
import { Backend } from '@/_axios';

export const LOAD_PROJECT_MATERIALS = 'LOAD_PROJECT_MATERIALS';
export const LOAD_SINGLE_PROJECT_MATERIALS = 'LOAD_SINGLE_PROJECT_MATERIALS';
export const SET_PROJECT_MATERIALS = 'SET_PROJECT_MATERIALS';

export const CREATE_PROJECT_MATERIAL = 'CREATE_PROJECT_MATERIAL';
export const SET_PROJECT_MATERIAL = 'SET_PROJECT_MATERIAL';

export const UPDATE_PROJECT_MATERIAL_COST = 'UPDATE_PROJECT_MATERIAL_COST';
export const SET_PROJECT_MATERIAL_COST = 'SET_PROJECT_MATERIAL_COST';
export const DELETE_PROJECT_MATERIAL_COST = 'DELETE_PROJECT_MATERIAL_COST';

export const DELETE_PROJECT_MATERIAL = 'DELETE_PROJECT_MATERIAL';
export const REMOVE_PROJECT_MATERIAL = 'REMOVE_PROJECT_MATERIAL';

export const PUSH_ON_LOADED_CALLBACK = 'PUSH_ON_LOADED_CALLBACK';

export const CREATE_PLANNED_PROJECT_MATERIALS = 'CREATE_PLANNED_PROJECT_MATERIALS';

const state = {
  projectMaterials: {},
  projectMaterialCosts: {},
  state: 'empty',
  onLoadedCallbacks: [],
};

const getters = {
  projectMaterialsByProject: (state) => {
    const projectMaterials = {};
    for (const materialId in state.projectMaterials) {
      const projectMaterial = state.projectMaterials[materialId];
      if (!projectMaterials[projectMaterial.project_id]) projectMaterials[projectMaterial.project_id] = {};
      projectMaterials[projectMaterial.project_id][projectMaterial.id] = projectMaterial;
    }
    return projectMaterials;
  },
  projectMaterialCostsByMaterialByYearweek: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      if (!projectMaterialCosts[materialCost.project_material_id]) projectMaterialCosts[materialCost.project_material_id] = {};

      projectMaterialCosts[materialCost.project_material_id][materialCost.yearweek] = projectMaterialCosts[materialCost.project_material_id][materialCost.yearweek] || 0;

      projectMaterialCosts[materialCost.project_material_id][materialCost.yearweek] += parseFloat(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByMaterialByMonth: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      if (!projectMaterialCosts[materialCost.project_material_id]) projectMaterialCosts[materialCost.project_material_id] = {};

      const month = `${materialCost.year}${materialCost.month < 10 ? '0' : ''}${materialCost.month}`;

      projectMaterialCosts[materialCost.project_material_id][month] = projectMaterialCosts[materialCost.project_material_id][month] || 0;

      projectMaterialCosts[materialCost.project_material_id][month] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByMaterialByQuarter: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      if (!projectMaterialCosts[materialCost.project_material_id]) projectMaterialCosts[materialCost.project_material_id] = {};

      const quarter = `${materialCost.year}${materialCost.quarter}`;

      projectMaterialCosts[materialCost.project_material_id][quarter] = projectMaterialCosts[materialCost.project_material_id][quarter] || 0;

      projectMaterialCosts[materialCost.project_material_id][quarter] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByMaterialByYear: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      if (!projectMaterialCosts[materialCost.project_material_id]) projectMaterialCosts[materialCost.project_material_id] = {};

      projectMaterialCosts[materialCost.project_material_id][materialCost.year] = projectMaterialCosts[materialCost.project_material_id][materialCost.year] || 0;

      projectMaterialCosts[materialCost.project_material_id][materialCost.year] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByYearweek: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      const projectId = state.projectMaterials[materialCost.project_material_id].project_id;
      if (!projectMaterialCosts[projectId]) projectMaterialCosts[projectId] = {};

      if (!projectMaterialCosts[projectId][materialCost.yearweek]) projectMaterialCosts[projectId][materialCost.yearweek] = 0;

      projectMaterialCosts[projectId][materialCost.yearweek] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByMonth: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      const projectId = state.projectMaterials[materialCost.project_material_id].project_id;
      if (!projectMaterialCosts[projectId]) projectMaterialCosts[projectId] = {};

      const month = `${materialCost.year}${materialCost.month < 10 ? '0' : ''}${materialCost.month}`;

      if (!projectMaterialCosts[projectId][month]) projectMaterialCosts[projectId][month] = 0;

      projectMaterialCosts[projectId][month] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByQuarter: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      const projectId = state.projectMaterials[materialCost.project_material_id].project_id;
      if (!projectMaterialCosts[projectId]) projectMaterialCosts[projectId] = {};

      const quarter = `${materialCost.year}${materialCost.quarter}`;

      if (!projectMaterialCosts[projectId][quarter]) projectMaterialCosts[projectId][quarter] = 0;

      projectMaterialCosts[projectId][quarter] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterialCostsByYear: (state) => {
    const projectMaterialCosts = {};
    for (const materialCostId in state.projectMaterialCosts) {
      const materialCost = state.projectMaterialCosts[materialCostId];
      const projectId = state.projectMaterials[materialCost.project_material_id].project_id;
      if (!projectMaterialCosts[projectId]) projectMaterialCosts[projectId] = {};

      if (!projectMaterialCosts[projectId][materialCost.year]) projectMaterialCosts[projectId][materialCost.year] = 0;

      projectMaterialCosts[projectId][materialCost.year] += parseInt(materialCost.cost);
    }
    return projectMaterialCosts;
  },
  projectMaterials: (state) => {
    return state.projectMaterials;
  }
};

const actions = {
  [LOAD_PROJECT_MATERIALS]: function ({ commit, state }) {
    state.status = 'loading';
    Backend.get('/api/project-materials').then((response) => {
      const projectMaterials = {};
      const projectMaterialCosts = {};
      response.data.projectMaterials.forEach((material) => {
        projectMaterials[material.id] = material;
      });
      response.data.projectMaterialCosts.forEach((materialCost) => {
        projectMaterialCosts[materialCost.id] = materialCost;
        projectMaterialCosts[materialCost.id].cost = parseFloat(projectMaterialCosts[materialCost.id].cost) / 100.0;
      });
      commit('SET_PROJECT_MATERIALS', { projectMaterials: projectMaterials, projectMaterialCosts: projectMaterialCosts });
    });
  },
  [LOAD_SINGLE_PROJECT_MATERIALS]: function ({ commit, state }, { id }) {
    state.status = 'loading';
    Backend.get('/api/single-project-materials', { params: { project_id: id } }).then((response) => {
      const projectMaterials = {};
      const projectMaterialCosts = {};
      response.data.projectMaterials.forEach((material) => {
        projectMaterials[material.id] = material;
      });
      response.data.projectMaterialCosts.forEach((materialCost) => {
        projectMaterialCosts[materialCost.id] = materialCost;
        projectMaterialCosts[materialCost.id].cost = parseFloat(projectMaterialCosts[materialCost.id].cost) / 100.0;
      });
      commit('SET_PROJECT_MATERIALS', { projectMaterials: projectMaterials, projectMaterialCosts: projectMaterialCosts });
    });
  },
  [PUSH_ON_LOADED_CALLBACK]: function ({ state }, callback) {
    if (state.status == 'done') {
      callback(state);
    } else {
      state.onLoadedCallbacks.push(callback);
    }
  },
  [CREATE_PROJECT_MATERIAL]: function ({ commit }, { projectId, name }) {
    Backend.post('/api/project-material', { projectId: projectId, name: name }).then((response) => {
      commit('SET_PROJECT_MATERIAL', { projectMaterial: response.data });
    });
  },
  [UPDATE_PROJECT_MATERIAL_COST]: function ({ commit }, { materialId, date, cost, uid }) {
    if (!cost) cost = 0;
    cost *= 100.0;
    Backend.post('/api/project-material-cost', { materialId: materialId, date: date, cost: cost }).then((response) => {
      response.data.cost = cost / 100.0;
      if (!cost) commit('DELETE_PROJECT_MATERIAL_COST', { projectMaterialCostId: response.data.id, uid: uid });
      else commit('SET_PROJECT_MATERIAL_COST', { projectMaterialCost: response.data, uid: uid });
    });
  },
  [DELETE_PROJECT_MATERIAL]: function ({ commit }, materialId) {
    return new Promise((resolve, reject) => {
      Backend.delete('/api/delete-project-material', { data: { materialId: materialId } }).then((response) => {
        commit('REMOVE_PROJECT_MATERIAL', { materialId: materialId });
        resolve();
      }, (err) => {
        console.log(err.response.data.message);
        reject(err.response.data.message);
      });
    });
  },
  [CREATE_PLANNED_PROJECT_MATERIALS]: function ({ commit }, data) {
    return Backend.post('/api/create-planned-material', data);
  }
};

const mutations = {
  [SET_PROJECT_MATERIALS]: function (state, { projectMaterials, projectMaterialCosts }) {
    Vue.set(state, 'projectMaterials', projectMaterials);
    state.projectMaterialCosts = projectMaterialCosts;
    state.status = 'done';
    state.onLoadedCallbacks.forEach((callback) => {
      callback(state);
    });
  },
  [SET_PROJECT_MATERIAL]: function (state, { projectMaterial }) {
    Vue.set(state.projectMaterials, projectMaterial.id, projectMaterial);
  },
  [SET_PROJECT_MATERIAL_COST]: function (state, { projectMaterialCost, uid }) {
    Vue.set(state.projectMaterialCosts, projectMaterialCost.id, projectMaterialCost);
    EventBus.$emit(`update-material-cost${uid}`);
  },
  [REMOVE_PROJECT_MATERIAL]: function (state, { materialId }) {
    Vue.delete(state.projectMaterials, materialId);
  },
  [DELETE_PROJECT_MATERIAL_COST]: function (state, { projectMaterialCostId, uid }) {
    Vue.delete(state.projectMaterialCosts, projectMaterialCostId);
    EventBus.$emit(`update-material-cost${uid}`);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
